<template>
  <v-app>
      <v-container>
          <v-row class="justify-content-center bold text-center">
              <v-col lg="1">Fecha</v-col>
              <v-col lg="2">Empleado</v-col>
              <v-col lg="2">Tipo de Gasto</v-col>
              <v-col lg="1">Monto</v-col>
              <v-col lg="1">Descripción</v-col>
              <v-col lg="1">...</v-col>
          </v-row>
          <v-row class="justify-content-center">
              <v-col lg="1"></v-col>
              <v-col lg="2"></v-col>
              <v-col lg="2"></v-col>
              <v-col lg="1"></v-col>
              <v-col lg="1"></v-col>
              <v-col lg="1">
                  <v-btn>
                      Ver
                  </v-btn>
              </v-col>
          </v-row>
      </v-container>
  </v-app>
</template>

<script>
export default {
    data(){
        return {
            users: []
        }
    }
}
</script>

<style>
    .bold{
        font-weight: bolder;
    }
</style>